export default __webpack_public_path__ + "static/media/delete-black.020411b3.svg";